import { Routes, Route } from "react-router-dom";
import PublicLayout from "./templates/publicLayout";
import AuthenticatedLayout from "./templates/authenticatedLayout";
import { PublicPath } from "./router/publicPath";
import { AuthenticatedPath } from "./router/authenticatedPath";
import ErrorScreen from "./pages/errorScreen";
import { useSessionTimeout } from "./hooks/useSessionTimeout";

export default function App() {
  useSessionTimeout();

  return (
    <Routes>
      {/* ログイン前の画面 */}
      <Route element={<PublicLayout />}>
        {PublicPath.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Route>

      {/* ログイン後の画面 */}
      <Route element={<AuthenticatedLayout />}>
        {AuthenticatedPath.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Route>
      {/* 存在しない場合のエラー画面 */}
      <Route path="*" element={<ErrorScreen />} />
    </Routes>
  );
}
